import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Include Both Helper File with needed methods
import {
	getScreenList as getScreenListApi,
	getScreen as getScreenApi,
	addNewScreen as addNewScreenApi,
	updateScreen as updateScreenApi,
	deleteScreen as deleteScreenApi,

	getPageList as getPageListApi,
	getPage as getPageApi,
	addNewPage as addNewPageApi,
	updatePage as updatePageApi,
	deletePage as deletePageApi,

	getPageTypeList as getPageTypeListApi,
	getPageType as getPageTypeApi,
	addNewPageType as addNewPageTypeApi,
	updatePageType as updatePageTypeApi,
	deletePageType as deletePageTypeApi,

	getGraphList as getGraphListApi,
	getGraph as getGraphApi,
	addNewGraph as addNewGraphApi,
	updateGraph as updateGraphApi,
	deleteGraph as deleteGraphApi,

	getReportTemplateList as getReportTemplateListApi,
	getReportTemplate as getReportTemplateApi,
	addNewReportTemplate as addNewReportTemplateApi,
	updateReportTemplate as updateReportTemplateApi,
	deleteReportTemplate as deleteReportTemplateApi,
} from '../../helpers/screen/backend_helper';

// Screen actions
export const getScreenList = createAsyncThunk('screen/getScreenList', async () => {
	try {
		const response = getScreenListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getScreen = createAsyncThunk('screen/getScreen', async (screen_id) => {
	try {
		const response = getScreenApi(screen_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewScreen = createAsyncThunk('screen/addNewScreen', async (screen) => {
	try {
		const response = addNewScreenApi(screen);
		toast.success('Screen agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar screen.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateScreen = createAsyncThunk('screen/updateScreen', async (screen) => {
	try {
		const response = updateScreenApi(screen);
		toast.success('Screen actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar screen.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteScreen = createAsyncThunk('screen/deleteScreen', async (screen) => {
	try {
		const response = await deleteScreenApi(screen);
		toast.success('Screen eliminado exitosamente.', { autoClose: 3000 });
		return { screen, ...response };
	} catch (error) {
		toast.error('Error al eliminar screen.', { autoClose: 3000 });
		throw new Error(error);
	}
});

// Page actions
export const getPageList = createAsyncThunk('page/getPageList', async () => {
	try {
		const response = getPageListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPage = createAsyncThunk('page/getPage', async (page_id) => {
	try {
		const response = getPageApi(page_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPage = createAsyncThunk('page/addNewPage', async (page) => {
	try {
		const response = addNewPageApi(page);
		toast.success('Página agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar page.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePage = createAsyncThunk('page/updatePage', async (page) => {
	try {
		const response = updatePageApi(page);
		toast.success('Página actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar page.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deletePage = createAsyncThunk('page/deletePage', async (page) => {
	try {
		const response = await deletePageApi(page);
		toast.success('Página eliminado exitosamente.', { autoClose: 3000 });
		return { page, ...response };
	} catch (error) {
		toast.error('Error al eliminar page.', { autoClose: 3000 });
		throw new Error(error);
	}
});

// Page Type actions
export const getPageTypeList = createAsyncThunk('page_type/getPageTypeList', async () => {
	try {
		const response = getPageTypeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPageType = createAsyncThunk('page_type/getPageType', async (page_type_id) => {
	try {
		const response = getPageTypeApi(page_type_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPageType = createAsyncThunk('page_type/addNewPageType', async (page_type) => {
	try {
		const response = addNewPageTypeApi(page_type);
		toast.success('Tipo de página agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar page_type.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePageType = createAsyncThunk('page_type/updatePageType', async (page_type) => {
	try {
		const response = updatePageTypeApi(page_type);
		toast.success('Tipo de página actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar page_type.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deletePageType = createAsyncThunk('page_type/deletePageType', async (page_type) => {
	try {
		const response = await deletePageTypeApi(page_type);
		toast.success('Tipo de página eliminado exitosamente.', { autoClose: 3000 });
		return { page_type, ...response };
	} catch (error) {
		toast.error('Error al eliminar page_type.', { autoClose: 3000 });
		throw new Error(error);
	}
});

// Graph actions
export const getGraphList = createAsyncThunk('graph/getGraphList', async () => {
	try {
		const response = getGraphListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGraph = createAsyncThunk('graph/getGraph', async (graph_id) => {
	try {
		const response = getGraphApi(graph_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewGraph = createAsyncThunk('graph/addNewGraph', async (graph) => {
	try {
		const response = addNewGraphApi(graph);
		toast.success('Gráfico agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar graph.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateGraph = createAsyncThunk('graph/updateGraph', async (graph) => {
	try {
		const response = updateGraphApi(graph);
		toast.success('Gráfico actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar graph.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteGraph = createAsyncThunk('graph/deleteGraph', async (graph) => {
	try {
		const response = await deleteGraphApi(graph);
		toast.success('Gráfico eliminado exitosamente.', { autoClose: 3000 });
		return { graph, ...response };
	} catch (error) {
		toast.error('Error al eliminar graph.', { autoClose: 3000 });
		throw new Error(error);
	}
});


// Report Template actions
export const getReportTemplateList = createAsyncThunk('report_template/getReportTemplateList', async () => {
	try {
		const response = getReportTemplateListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getReportTemplate = createAsyncThunk('report_template/getReportTemplate', async (report_template_id) => {
	try {
		const response = getReportTemplateApi(report_template_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewReportTemplate = createAsyncThunk('report_template/addNewReportTemplate', async (report_template) => {
	try {
		const response = addNewReportTemplateApi(report_template);
		toast.success('Plantilla de reporte agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar report_template.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateReportTemplate = createAsyncThunk('report_template/updateReportTemplate', async (report_template) => {
	try {
		const response = updateReportTemplateApi(report_template);
		toast.success('Plantilla de reporte actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar report_template.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteReportTemplate = createAsyncThunk('report_template/deleteReportTemplate', async (report_template) => {
	try {
		const response = await deleteReportTemplateApi(report_template);
		toast.success('Plantilla de reporte eliminado exitosamente.', { autoClose: 3000 });
		return { report_template, ...response };
	} catch (error) {
		toast.error('Error al eliminar report_template.', { autoClose: 3000 });
		throw new Error(error);
	}
});
